import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { Modal } from "PFComponents/modal";
import { Typography } from "PFComponents/typography";
import { useActivityEconomicsScenarioDelete } from "PFCore/hooks/queries/activity";
import { Id } from "PFTypes";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

type RemoveScenarioModalProps = {
  scenarioId: Id;
  activityId: Id;
  onRemove?: () => void;
  onClose: () => void;
};

export const RemoveScenarioModal = ({
  scenarioId,
  activityId,
  onClose,
  onRemove
}: RemoveScenarioModalProps) => {
  const { showGrowl } = useGrowlStoreActions();
  const { t } = useTranslation("activities", { keyPrefix: "show.economics.removeScenarioModal" });
  const { t: defaultT } = useTranslation("translation");

  const { mutate: deleteScenario } = useActivityEconomicsScenarioDelete(activityId);

  const handleDelete = useCallback(() => {
    deleteScenario(scenarioId, {
      onSuccess: () => {
        showGrowl({
          kind: "success",
          message: t("deleteSuccess")
        });

        onRemove?.();
      },
      onError: () => {
        showGrowl({
          kind: "error",
          message: t("deleteError")
        });
      }
    });
  }, [deleteScenario, showGrowl, onRemove, scenarioId, t]);

  return (
    <Modal
      title={t("title")}
      onOK={handleDelete}
      onClose={onClose}
      labelOK={defaultT("remove")}
      kindOK="danger"
    >
      <Typography variant="bodyRegular">{t("body")}</Typography>
    </Modal>
  );
};
